export const BASE_URL = 'https://devfest2022.duckdns.org';
